module.exports = __webpack_public_path__ + "img/13.834c41b9.png";